export const ContaReceberSteps = [
  {
    target: '.stepBarraPesquisa',
    content: 'Neste campo você pode realizar pesquisas rápidas de informações presentes nas colunas da tabela.',
    disableBeacon: true,
    spotlightPadding: 4,
    styles: {
      spotlight: {
        marginTop: 10,
        marginBottom: 5,
      },
    },
  },
  {
    target: '.stepBuscaAvancada',
    content: 'Utilizando este comando, você poderá utilizar vários filtros para uma busca avançada.',
    spotlightPadding: -5,
  },
  {
    target: '.stepAcoesBoleto',
    content: 'Para visualizar as opções de ações relacionadas ao boleto, acione este ícone.',
    styles: {
      spotlight: {
        borderRadius: 50,
      },
    },
  },
  {
    target: '.stepVisualizarDashboards',
    content: 'Para visualizar os gráficos para análise gerencial do contas a receber, acione este ícone.',
    styles: {
      spotlight: {
        borderRadius: 50,
      },
    },
  },
  {
    target: '.stepCaixaSelecao',
    content:
      'Acionando essa seta ao lado da caixa de seleção, você tem a escolha de selecionar todos os registros exibidos no resultado da pesquisa, todos os registros da página e desmarcar todos.',
    spotlightPadding: -2,
  },
  {
    target: '.stepIconeOrdenacao',
    content: 'Com este ícone você consegue reordenar os registros exibidos no resultado da pesquisa.',
    styles: {
      spotlight: {
        marginTop: '13px',
        marginLeft: '90px',
        maxHeight: '20px',
        maxWidth: '20px',
      },
    },
    offset: -10,
    placement: 'left',
  },
  {
    target: '.stepNossoNumero',
    content:
      'Toda comunicação com o banco poderá ser acompanhada por aqui: Cobranças pendentes de registro, cobrança com remessa gerada, cobranças registradas com sucesso ou erro e cobranças baixadas.',
  },
  {
    target: '.stepIconeEditar',
    content: 'Acione este ícone quando desejar fazer a edição de algum registro.',
    spotlightPadding: 5,
  },
  {
    target: '.stepIconeExcluir',
    content: 'Acione este ícone quando desejar fazer a exclusão de algum registro.',
    spotlightPadding: 5,
  },
  {
    target: '.stepIconeBaixar',
    content: 'Acione este ícone quando desejar realizar a baixa de algum registro.',
    spotlightPadding: 5,
  },
  {
    target: '.stepIconeCancelarBaixa',
    content: 'Acione este ícone quando desejar realizar o cancelamento da baixa de algum registro.',
    spotlightPadding: 5,
  },
  {
    target: '.stepEnviarNF',
    content: 'Acione este ícone quando desejar enviar a NF da cobrança por e-mail.',
    spotlightPadding: 5,
  },
  {
    target: '.stepVisualizarBoleto',
    content: 'Acione este ícone quando desejar visualizar algum boleto.',
    spotlightPadding: 5,
  },
  {
    target: '.stepRodape',
    content:
      'No rodapé da página você consegue visualizar a quantidade de registros selecionados, escolher a quantidade de registros que deseja visualizar por página, visualizar quantos registros foram exibidos no total e selecionar a página desejada.',
    spotlightPadding: -20,
    styles: {
      spotlight: {
        maxWidth: '1000px',
      },
    },
  },
  {
    target: '.stepFabContaReceber',
    content:
      'Acionando este ícone, o sistema exibirá as opções para cadastrar um novo registro, baixar, cancelar baixa, excluir e enviar NF por e-mail para mais de um registro em uma única vez, visualizar as receitas regulares e importar planilha.',
    styles: {
      spotlight: {
        borderRadius: 50,
      },
    },
  },
];
